import React, { useCallback, useEffect, useState } from 'react';

import { Modal, Typography, Steps, message } from 'antd';

import { Opreg } from '../../../models';

import { TableWrapper, useTranslation,Button } from 'soxo-bootstrap-core';

import QuestionCard from '../questioncard/questioncard';

const { Title } = Typography;

export function Questionaire({
    mode,
    reference_id,
    onVerify,
    physican,
    enableQuestionnaireVerifier,

    /**Attribute to show questionaire , Vietnam We will default Old Questionnaire view option . In India and default would be new version .  */
    enableLegacyQuestionnaire,
    isEditable,
    questionaireCategory,
    questionaireMode,
    callback
}) {
    const { t } = useTranslation(); // To translate to another language

    const { Step } = Steps;

    let [visible, setVisible] = useState(false);
    let [loading, setLoading] = useState(false);

    var [questions, setQuestions] = useState([]);

    const [currentStep, setCurrentStep] = useState(0); // State to manage current step
    const [data, setData] = useState([]);

    /**
     * Get call to load questionnaire information
     */
    useEffect(() => {
        loadQuestionaire();
    }, []);

    function loadQuestionaire() {
        let formBody = {
            bill_id: reference_id,
            mode: mode,
            isEditable: isEditable,
            questionaire_category: questionaireCategory,
            questionaire_mode: questionaireMode,
        };

        Opreg.loadQuestionaire(formBody).then((result) => {
            if (result.data.length) {
                setQuestions(result.data);
            } else {
            }
        });
    }

    const handleSubmitQuestionnaire = () => {
        // Call onVerify callback passed in props
        onVerify();
        setVisible(false); // Close modal
    };

    // Group questions by `group`
    const groupedQuestions = questions?.reduce((acc, question, index) => {
        const group = question.group; // Access `group` from each question
        if (!acc[group]) {
            acc[group] = [];
        }
        acc[group].push({ ...question, index });
        return acc;
    }, {});

    // for groupName
    const groupNames = Object.keys(groupedQuestions);

    // Handlers for next and previous steps
    const handleNext = () => {
        if (currentStep < groupNames.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handlePrev = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    /**
     *
     * @param {*} event
     * @param {*} value
     */

    var columns = [
        {
            title: 'Sl No',
            dataIndex: 'index',
            render: (value, item, index) => {
                return index + 1;
            },
        },
        {
            title: 'Questions',
            key: 'questions',

            render: (ele) => {
                return ele.description;
            },
        },
        {
            title: 'Value',
            key: 'value',

            render: (ele) => {
                return ele.values;
            },
        },

        {
            title: 'Remarks',
            key: 'Remark',

            render: (ele) => {
                return ele.remarks;
            },
        },
    ];
    /**
     * Handles changes to an answer and updates the state accordingly.
     *
     * @function handleAnswerChange
     * @param {Object} updatedRecord - The updated record containing the new values.
     */
    const handleAnswerChange = (updatedRecord) => {
            // Update only if editing is allowed
        if (isEditable)
            setQuestions((prevQuestions) =>
                prevQuestions.map((q) =>
                    q.id === updatedRecord.id
                        ? {
                              ...q,
                              ...(updatedRecord.type === 'RDB' ? { values: updatedRecord.values } : { remarks: updatedRecord.values }),
                          }
                        : q
                )
            );
    };
    /**
     * Handles saving the questionnaire by filtering answered questions and sending data to the server.
     *
     * @async
     * @function handleSave
     * @returns {Promise<void>} - Submits the questionnaire and updates the UI accordingly.
     */
    async function handleSave() {
        setLoading(true);
        // Filter out questions that have either `values` or `remarks` filled
        let filter = questions.filter((ele) => ele.values || ele.remarks);
        let formBody = {
            question: filter,
            bill_id: reference_id,
            reftype:questionaireMode
        };
        // Construct request body with filtered questions and bill ID

        let response = await Opreg.createQuestionaire(formBody);
        // Show success or error message based on response

        if (response.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
        setVisible(false);
        setLoading(false);
        await loadQuestionaire();
        callback(questions)
    }

    return (
        <div className="questionaire">
            {/* Conditional rendering based on enableQuestionnaireVerifier */}
            {!enableQuestionnaireVerifier ? (
                <div className="paga-actions">
                    <Button
                        type="primary"
                        size={'small'}
                        onClick={() => {
                            setVisible(true);
                        }}
                    >
                        {t('View Questionnaire')}
                    </Button>
                </div>
            ) : (
                <div className="questionnaire-section">
                    <div className="description">
                        {!physican ? (
                            <Typography.Text>
                                {t(
                                    "Check and verify the guest's questionnaire details here. Submission will only be enabled after verification is completed."
                                )}
                            </Typography.Text>
                        ) : (
                            <Typography.Text>{t("The guest's questionnaire has been verified.")}</Typography.Text>
                        )}
                    </div>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            setVisible(true);
                        }}
                    >
                        {t('View Questionnaire')}
                    </Button>
                </div>
            )}

            {/* Modal with Questionnaire */}
            <Modal
                destroyOnClose={true}
                visible={visible}
                footer={
                    !enableQuestionnaireVerifier
                        ? null
                        : [
                              <Button key="cancel" onClick={() => setVisible(false)}>
                                  {t('Cancel')}
                              </Button>,
                              <Button key="submit" type="primary" disabled={physican} onClick={handleSubmitQuestionnaire}>
                                  {!physican ? t('Verify') : t('Verified')}
                              </Button>,
                          ]
                }
                className="custom-modal"
                onCancel={() => {
                    setVisible(false);
                }}
                // width={'40%'}
                maskClosable={false}
            >
                <div>
                    {/* <div className="left">
                        <Title level={4}>{t('Questionnaire')}</Title>
                    </div> */}

                    {/* Render QuestionCards instead of table */}
                    {/* Steps for group navigation */}
                    {/* <Steps current={currentStep}>
                        {groupNames.map((group, index) => (
                            <Step key={index} />
                        ))}
                    </Steps> */}

                    {/* Navigation Buttons */}
                    {/* Show navigation buttons only for new questionnaire */}
                    {!enableLegacyQuestionnaire && (
                        <div className="question-action" style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '20px', gap: '20px' }}>
                            {isEditable && currentStep === groupNames?.length - 1 ? (
                                <Button size="small" type="primary" onClick={handleSave} loading={loading}>
                                    Save
                                </Button>
                            ) : null}
                            <Button size="small" disabled={currentStep === 0} onClick={handlePrev}>
                                Previous
                            </Button>
                            <Button
                                size="small"
                                type="primary"
                                disabled={currentStep === groupNames.length - 1}
                                onClick={handleNext}
                                style={{ marginLeft: '10px' }}
                            >
                                Next
                            </Button>
                        </div>
                    )}

                    {enableLegacyQuestionnaire ? (
                        // Legacy Questionnaire View
                        <>
                            <div className="left">
                                <Title level={4}>Questionnaire</Title>
                            </div>
                            <TableWrapper records={questions} columns={columns} pagination={false} />
                            {/* scroll={{ x: true }} */}
                        </>
                    ) : (
                        // New Questionnaire View
                        <>
                            {groupNames.length > 0 ? (
                                <>
                                    <Title level={5} style={{ color: 'Orange' }}>
                                        {groupNames[currentStep]}
                                    </Title>
                                    {groupedQuestions[groupNames[currentStep]]
                                     ?.sort((a, b) => a.sl_no - b.sl_no) // sort by sl_id ascending
                                    .map((record, index) => (
                                        //{ description, type, input_list, values, remarks }
                                        <QuestionCard
                                          
                                            key={record.sl_no} // safer than index
                                            questionOne={record.description}
                                            radio={record.type === 'RDB'}
                                            radioLabels={record.input_list ? record.input_list.split(',') : []}
                                            input={record.type === 'TBX'}
                                            answer={record.values || record.remarks}
                                            isEditable={isEditable}
                                            onChange={handleAnswerChange}
                                            record={record}
                                        />
                                    ))}
                                </>
                            ) : (
                                <p>No questions available for this group.</p>
                            )}
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
}
